/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

export const SDK_MAX_SESSION_AGE_MS = 25 * 60 * 1000;

let _sdkLoadTimestamp = Date.now();

/**
 * @returns Milliseconds elapsed since the reCAPTCHA SDK session was last loaded.
 */
export function getSDKSessionAgeMs(): number {
  return Date.now() - _sdkLoadTimestamp;
}

/**
 * Resets the SDK session age baseline to now (call after a fresh SDK reload).
 */
export function resetSDKSessionTimestamp(): void {
  _sdkLoadTimestamp = Date.now();
}
